import React from 'react';
import { Typography } from '@material-ui/core';

// Import components
import { PolicyListItem } from 'components/elements';

// Import utilities
import { useTranslations } from 'components/utilities';

const TermsAndConditionsPolicyListItem = () => {
	const { t } = useTranslations();

	const conditions = t('policy.termsAndConditions.conditions.content', {
		returnObjects: true
	});

	const notes = t('policy.termsAndConditions.notes.content', {
		returnObjects: true
	});

	return (
		<PolicyListItem
			title={t('policy.termsAndConditions.title')}
			content={
				<>
					<Typography variant="h4">
						{t('policy.termsAndConditions.conditions.title')}
					</Typography>

					<ul>
						{Object.values(conditions).map((condition) => (
							<li key={condition}>
								<Typography
									component="span"
									variant="subtitle1"
								>
									{condition}
								</Typography>
							</li>
						))}
					</ul>

					<Typography variant="h4">
						{t('policy.termsAndConditions.notes.title')}
					</Typography>

					<ul>
						{Object.values(notes).map((note) => (
							<li key={note}>
								<Typography
									component="span"
									variant="subtitle1"
								>
									{note}
								</Typography>
							</li>
						))}
					</ul>
				</>
			}
		/>
	);
};

export default TermsAndConditionsPolicyListItem;
